import Pusher from 'pusher-js';
import config from 'config';

const pusher = new Pusher(config.pusher.key, {
    cluster: config.pusher.cluster,
    // encrypted: true,

});


export default pusher;